import { __extends } from "tslib";
import { deserializeAws_restJson1_1DeleteApnsSandboxChannelCommand, serializeAws_restJson1_1DeleteApnsSandboxChannelCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteApnsSandboxChannelCommand = /** @class */ (function (_super) {
    __extends(DeleteApnsSandboxChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteApnsSandboxChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteApnsSandboxChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteApnsSandboxChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1DeleteApnsSandboxChannelCommand(input, context);
    };
    DeleteApnsSandboxChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1DeleteApnsSandboxChannelCommand(output, context);
    };
    return DeleteApnsSandboxChannelCommand;
}($Command));
export { DeleteApnsSandboxChannelCommand };
//# sourceMappingURL=DeleteApnsSandboxChannelCommand.js.map